import React, { useEffect } from 'react';
import styled from 'styled-components';
import color from '@deprecated-ui/_style/color';
import { useDispatch } from 'react-redux';
import { screenerEffects } from '../../slice';
import ScreenerButton from './ScreenerButton';
import ScreenerFavoritesBar from './FavoritesBar';
import ScreenerFavoriteDropdown from './FavoritesDropdown';

const SHeaderContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;
  background: ${color.light};
  border-radius: 3px;
  border: 1px solid ${color.gainsboro};
`;

const SHeaderTopContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid ${color.gainsboro};
`;

const SHeaderBottomContainer = styled.div`
  padding: 10px 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SHeaderTopContainerTitle = styled.h5`
  font-weight: 700;
  color: ${color.dimgray};
  font-size: 16px;
  cursor: pointer;
  margin: 0px;
`;

const Index = () => {
  const { getScreenerFavorites, getScreenerUniverse } = screenerEffects;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getScreenerFavorites());
    dispatch(getScreenerUniverse());
  }, []);

  return (
    <SHeaderContainer>
      <SHeaderTopContainer>
        <SHeaderTopContainerTitle>Stock Screener</SHeaderTopContainerTitle>
        <ScreenerButton />
      </SHeaderTopContainer>
      <SHeaderBottomContainer>
        <ScreenerFavoritesBar />
        <ScreenerFavoriteDropdown />
      </SHeaderBottomContainer>
    </SHeaderContainer>
  );
};

export default Index;
